<template>
  <div class="vp-day-picker">
    <div class="vp-day-picker__label-row">
      <span v-if="showLabel" ref="label" class="vp-day-picker__label">
        <slot name="label">Days of Schedule</slot>
      </span>
      <slot name="affix" />
    </div>
    <div class="vp-day-picker__days">
      <vp-button v-for="day in eventDays" :title="day" :class="['icon-button', { 'no-fill': !days[day]}]" :ref="day" :key="day" :styles="buttonStyles" :data-disabled="disabled" @click="update(day)">{{ day.slice(0, 1) }}</vp-button>
    </div>
  </div>
</template>

<script>
import VpButton from '../vp-button/VpButton.vue';

const eventDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export default {
  name: 'VpDayPicker',
  components: { VpButton },
  props: {
    value: {
      type: Object,
      default: null,
      validator(days) {
        const requiredKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const requiredNumbers = [0, 1, 2, 3, 4, 5, 6];
        const isValid = requiredKeys.some(key => key in days || requiredNumbers.some(key => key in days));
        if (!isValid) console.error('Invalid Prop, value must include either Days of the week, or Numbers 0-6 with respective values. Received:', Object.keys(days));
        return isValid;
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    eventDays: () => eventDays,
    buttonStyles() {
      return {
        hoverBorder: '#016699 solid 2px',
      };
    },
  },
  data() {
    const days = {};
    for (const day of eventDays) days[day] = false;
    return { days };
  },
  watch: {
    value: {
      immediate: true,
      handler(days) {
        if (!days) return null;
        const hasDiff = !days ? false : JSON.stringify(days || {}) !== JSON.stringify(this.days);
        return hasDiff ? this.init() : null;
      },
    },
    days: {
      deep: true,
      handler(days) {
        if (!days) return null;
        const hasDiff = !days ? false : JSON.stringify(days || {}) !== JSON.stringify(this.value);
        return hasDiff ? this.$emit('input', days) : null;
      },
    },
  },
  emits: ['input'],
  methods: {
    init() {
      if (!this.value) return null;
      const sets = Object.entries(this.value);
      const numberKeys = sets.filter(([key]) => !isNaN(key));
      const dayKeys = sets.filter(([key]) => eventDays.includes(key));
      if (numberKeys.length) {
        for (const [key, value] of numberKeys) {
          try {
            const day = eventDays[key];
            if (day) this.days[day] = value;
          } catch (_) {
            continue; /** continue passively */
          }
        }
      }
      if (dayKeys.length) {
        for (const [day, value] of dayKeys) {
          try {
            if (day) this.days[day] = value;
          } catch (_) {
            continue; /** continue passively */
          }
        }
      }
    },
    update(day) {
      if (!day || this.disabled) return null;
      if (day in this.days) this.days[day] = !this.days[day];
    },
  },
};
</script>

<style lang="scss" scoped>
.vp-day-picker {
  display: flex;
  text-align: left;
  flex-direction: column;
  &__label {
    flex: 100%;
    gap: 0.25rem;
    height: 25px;
    font-size: 14px;
    display: flex;
    margin: 0 0 0 4px;
    &-row {
      display: flex;
    }
  }
  &__days {
    display: flex;
    column-gap: 0.5rem;
    & > button {
      width: 30px !important;
      height: 20px !important;
      border-radius: 1.25rem !important;
    }
  }
  &::v-deep .vcl-button[data-disabled] {
    cursor: not-allowed;
  }
}
</style>
